import { asyncLoad } from "./makeAsync"

/**
 * Walks through the components to render and fetches any async components
 * @param routerComponents
 * @returns {Promise.<*>}
 */
export default function fetchAsyncLoads(components) {
  // call the functions for promises
  const loads = components.reduce((acc, Component) => {
    if (!Component) {
      // wrapper or stateless
      return acc
    }

    if (Component.WrappedComponent) {
      return Component.WrappedComponent.maybeAsyncLoad
        ? acc.concat(asyncLoad(Component.WrappedComponent))
        : acc
    }

    return Component.maybeAsyncLoad ? acc.concat(asyncLoad(Component)) : acc
  }, [])

  return Promise.all(loads)
}
